import { PortalPouzivateliaApi } from '../client-portal'
import { definePlugin } from '/@src/app'
import { useUserSession } from '/@src/stores/userSession'
import * as apisPortal from '/@src/client-portal/api'
import { useRoute } from 'vue-router'
import * as useFeatureFlags from '/@src/composable/useFeatureFlags'

export default definePlugin(async ({ router, pinia }) => {
  const userSession = useUserSession(pinia)
  const portalApi = new apisPortal.PortalAuthApi()
  const route = useRoute()

  // 1. Check token validity before the app start
  if (userSession.isLoggedIn) {
    try {
      // Do api request call to retreive user profile.
      // Note that the api requests the json-server
      const api = new PortalPouzivateliaApi()
      const { data: user } = await api.getCurrentProfilePortalPouzivatelia()
      userSession.setUser(<any>user)
    } catch (err) {
      // delete stored token if it fails
      userSession.logoutUser()
    }
  }

  router.beforeEach(async (to, from) => {
    if (
      userSession.isLoggedIn &&
      !['vyber-subjektu', 'vyber-subjektu-eid', 'callback'].includes(to.name as string)
    ) {
      userSession.setRedirect(undefined)
    }

    // 2. If the page requires auth, check if user is logged in
    // if not, redirect to login page.
    const bearerTokenIS = new URL(document.location).searchParams.get('bearerToken')
    if (to.meta.requiresAuth && !userSession.isLoggedIn && !bearerTokenIS) {
      // TODO: MB lepsie spravit, ad hoc pre sken QR
      if (
        to.name === 'app-ziadosti-ziadostId-zhrnutie' &&
        from.name !== 'app-ziadosti-ziadostId-zhrnutie'
      ) {
        try {
          const locationURL = location.protocol + '//' + location.host
          const response = await portalApi.loginPortalAuth(`${locationURL}/callback`)
          userSession.setRedirect(to.fullPath)
          window.location.replace(response.data.url!)
        } catch (error: any) {
          console.error(error)
        }
      }

      return {
        name: 'app-vyzvy',
        // save the location we were at to come back later
        query: { redirect: to.fullPath },
      }
    }
  })

  router.beforeEach(async (to) => {
    if (
      ['app-projekty', 'app-zop'].includes(to.name as string) &&
      !useFeatureFlags.isFeatureFlag(useFeatureFlags.FeatureFlags.ZOP)
    ) {
      window.location.href = `/404${to.fullPath}`
    }
  })
})
